module.exports = __webpack_public_path__ + "img/Sesame.f2a3d460.svg";